import { render, staticRenderFns } from "./addShortcut.vue?vue&type=template&id=e42fc472&scoped=true"
import script from "./addShortcut.vue?vue&type=script&lang=js"
export * from "./addShortcut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42fc472",
  null
  
)

export default component.exports